<template>
  <div class="about-content container py-4">
    <!-- PREVIEW MODE -->
    <div v-if="!editMode" class="card p-4 shadow-sm border-primary">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h5 class="fw-bold">
          <i class="bi bi-info-circle-fill me-2 text-primary"></i>
          About Content Preview
        </h5>
        <button class="btn btn-outline-primary btn-sm" @click="enableEdit">
          <i class="bi bi-pencil-fill"></i> Edit
        </button>
      </div>

      <!-- ABOUT -->
      <div class="mb-3">
        <label class="fw-bold"
          ><i class="bi bi-building me-1"></i> About Academy</label
        >
        <p class="border rounded p-2 bg-light">
          {{ form.about_academy || "No content added" }}
        </p>
      </div>

      <!-- VISION -->
      <div class="mb-3">
        <label class="fw-bold"
          ><i class="bi bi-eye-fill me-1"></i> Vision</label
        >
        <p class="border rounded p-2 bg-light">
          {{ form.vision || "No content added" }}
        </p>
      </div>

      <!-- MISSION -->
      <div class="mb-3">
        <label class="fw-bold"
          ><i class="bi bi-flag-fill me-1"></i> Mission</label
        >
        <p class="border rounded p-2 bg-light">
          {{ form.mission || "No content added" }}
        </p>
      </div>

      <!-- IMAGE -->
      <div v-if="imagePreview" class="mb-3">
        <label class="fw-bold"
          ><i class="bi bi-image me-1"></i> About Image</label
        >
        <div class="border rounded p-2 bg-light d-inline-block">
          <img
            :src="imagePreview"
            class="img-fluid rounded"
            style="max-width: 250px"
          />
        </div>
      </div>
    </div>

    <!-- EDIT MODE -->
    <form
      v-else
      @submit.prevent="saveAbout"
      class="card p-4 shadow-sm border-success"
    >
      <h5 class="fw-bold mb-4 text-success">
        <i class="bi bi-pencil-square me-2"></i> Edit About Content
      </h5>

      <!-- ABOUT -->
      <div class="mb-3">
        <label class="form-label"
          ><i class="bi bi-building me-1"></i> About Academy</label
        >
        <textarea
          class="form-control"
          rows="3"
          v-model="form.about_academy"
        ></textarea>
      </div>

      <!-- VISION -->
      <div class="mb-3">
        <label class="form-label"
          ><i class="bi bi-eye-fill me-1"></i> Vision</label
        >
        <textarea
          class="form-control"
          rows="2"
          v-model="form.vision"
        ></textarea>
      </div>

      <!-- MISSION -->
      <div class="mb-3">
        <label class="form-label"
          ><i class="bi bi-flag-fill me-1"></i> Mission</label
        >
        <textarea
          class="form-control"
          rows="2"
          v-model="form.mission"
        ></textarea>
      </div>

      <!-- IMAGE -->
      <div class="mb-3">
        <label class="form-label"
          ><i class="bi bi-image me-1"></i> About Image</label
        >
        <input type="file" class="form-control" @change="handleImage" />
        <div v-if="imagePreview" class="mt-2">
          <img
            :src="imagePreview"
            class="img-fluid rounded"
            style="max-width: 250px"
          />
        </div>
      </div>

      <div class="d-flex justify-content-end mt-4">
        <button
          type="button"
          class="btn btn-secondary me-2"
          @click="editMode = false"
        >
          <i class="bi bi-x-circle me-1"></i> Cancel
        </button>
        <button class="btn btn-success" :disabled="loading">
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm me-2"
          ></span>
          <span v-else><i class="bi bi-save me-1"></i> Save</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AboutContent",
  data() {
    return {
      editMode: false,
      loading: false,
      imagePreview: "",
      form: {
        about_academy: "",
        vision: "",
        mission: "",
        about_image: null,
      },
    };
  },
  mounted() {
    this.loadContent();
  },
  methods: {
    enableEdit() {
      this.editMode = true;
    },
    loadContent() {
      axios
        .get("/about-content")
        .then((res) => {
          if (res.data) {
            this.form.about_academy = res.data.about_academy || "";
            this.form.vision = res.data.vision || "";
            this.form.mission = res.data.mission || "";
            this.imagePreview = res.data.about_image || "";
          }
        })
        .catch(() => {
          console.error("Error fetching about content");
        });
    },
    handleImage(e) {
      const file = e.target.files[0];
      if (file) {
        this.form.about_image = file;
        this.imagePreview = URL.createObjectURL(file);
      }
    },
    saveAbout() {
      this.loading = true;
      const formData = new FormData();
      formData.append("about_academy", this.form.about_academy);
      formData.append("vision", this.form.vision);
      formData.append("mission", this.form.mission);
      if (this.form.about_image)
        formData.append("about_image", this.form.about_image);

      axios
        .post("/save-about-content", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          alert("About content updated successfully");
          this.editMode = false;
          this.loadContent();
        })
        .catch(() => {
          alert("Error updating content");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.about-content {
  max-width: 800px;
  margin: auto;
}

.card p {
  margin: 0;
}

.modal-footer button i {
  vertical-align: middle;
}

textarea.form-control {
  resize: vertical;
}
</style>
